<script>
import Layout from "../../../layouts/manage";
import PageHeader from "@/components/page-header";
import ReportPageHeader from "@/components/report-page-header";
import appConfig from "@/app.config";
import Select from "@/components/c-select";
import Input from "@/components/c-input";
import Button from "@/components/c-button";
import moment from 'moment'
import { manageReportService } from "../../../../services/managements/reports/report.service.js";


/* eslint-disable no-console */
export default {
  page: {
    title: "Service Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Layout, 
    PageHeader, 
    ReportPageHeader,
    Button,
    Input,
    Select, 
  },
  data() {
    return {
      title: "Service Report",
      data: [],
      projects: {},
      

      dataProjectId: 0,
      // dataMonth: (moment().month() + 1) <10 ? '0'+(moment().month() + 1): (moment().month() + 1),
      // dataYear: moment().year(),
      dataStartDate: '',
      dataEndDate: '',
    };
  },
  mounted() {
    //this.loadingData(this.$route.params.id);
    this.loadServiceReport();
    
  },
  methods: {
    
    loadServiceReport: function() {
      let data = '?project_id='+this.dataProjectId+
        '&start_date='+this.dataStartDate+
        '&end_date='+this.dataEndDate
      
      manageReportService.getServiceReport(data)
        .then(response => {
          this.data = response.data;
          this.dataStartDate = this.data.date.start_date;
          this.dataEndDate = this.data.date.end_date;
          console.log(data);
        });
        
    },
    submitSearch: function() {
      this.loadServiceReport();
    },
    dateFormat: function(value){
      return moment(String(value)).format('DD/MM/YYYY');
    },
    moment: function () {
      return moment();
    },
    formatCurrency(value) {
      if(value == 0 ){
        return '$0.00';
      }
      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
    print() {
      window.print();
    },
    total(column_name, data){
      if(data){
        let total = 0;
        data.map(function(item){
            total += item[column_name];
        });

        return total;
      }
     
     
    }
  }
};

</script>

<template>
  <Layout>
    <PageHeader @click="print()" :add="{icon: 'bx bx-printer', title: 'general.print'}" :title="'របាយការណ៍សេវាកម្ម និងទឹកភ្លើង'" />
      <div id="print-area">
        <!-- <center> -->
          <div class="row search-area">
              
              <div class="col-sm-2">
                <label>គម្រោង</label>
                <Select
                  :id="'id'"
                  :text="'name'"
                  :editable="true"
                  :list="{data: this.data.projects}"
                  v-model="dataProjectId"
                /> 
              </div>
              <div class="col-sm-2">
                <Input
                    :type="'date'"
                    :id="'invoice_date'"
                    v-model="dataStartDate"
                    :label="'manage.start-date'"
                  />
                <!-- <Select
                  :id="'id'"
                  :text="'label'"
                  :editable="true"
                  :list="{data: this.data.date.start_date}"
                  v-model="dataMonth"
                />  -->
              </div>
              
               <div class="col-sm-2">
                <Input
                    :type="'date'"
                    :id="'end_date'"
                    v-model="dataEndDate"
                    :label="'manage.end-date'"
                  />
                <!-- <Select
                  :id="'id'"
                  :text="'label'"
                  :editable="true"
                  :list="{data: this.data.date.end_date}"
                  v-model="dataYear"
                />  -->
              </div>
              <div class="col-sm-2 pt-2">
                <br>
                <Button v-bind:icon="'bx bx-search'"
                  @click="submitSearch()" 
                  v-bind:buttonType="'button'"
                  v-bind:variant="'primary'"
                  v-bind:title="$t('general.search')" 
                />
              </div>
          </div>
          <div class="col dblack box-a4l">
            <ReportPageHeader
              :title="'របាយការណ៍សេវាកម្ម និងទឹកភ្លើង'"
              :titleDate="this.data.date?(this.data.date.start_date_kh + ' ដល់ ' + this.data.date.end_date_kh):''"
            />
            <br/>
            <table class="content-general h8 project-sumary-table report-table" width="100%">
              
                <tr class="thead">
                  <th class="text-start px-2">ឈ្មោះសេវាកម្ម</th>
                  <th class="text-end px-2">ទឹកប្រាក់សរុប</th>
                  <th class="text-end px-2">ទឹកប្រាក់ជំពាក់</th>
                  <th class="text-end px-2">ទឹកប្រាក់បានទទួល</th>
                </tr>
               
              
              <tbody v-if="data">
                <tr v-for="(list, index) in data.services" :key="index" >
                  <td class="text-start px-2">{{list.name_kh}}</td>
                  <td class="text-end px-2">{{formatCurrency(list.total_amount)}}</td>
                  <td class="text-end text-danger px-2">{{formatCurrency(list.debt_amount)}}</td>
                  <td class="text-end px-2">{{formatCurrency(list.paid_amount)}}</td>
                </tr>

                <tr class="bg-warning">
                  <td class="text-end">សរុប</td>
                  <td class="text-end px-2">{{formatCurrency(total('total_amount', this.data.services))}}</td>
                  <td class="text-end px-2">{{formatCurrency(total('debt_amount', this.data.services))}}</td>
                  <td class="text-end px-2">{{formatCurrency(total('paid_amount', this.data.services))}}</td>
                </tr>

                <!-- income  -->
                <tr>
                  <td class="text-end px-2" colspan="2" rowspan="5">
                    ចំណូល/Income
                  </td>
                  <td class="text-end px-2 bg-secondary">ចំណូលសរុបទាំងអស់</td>
                  <td class="text-end px-2 bg-secondary">{{formatCurrency( this.data.payment.cash_amount + this.data.payment.bank_amount + this.data.payment.deposit_amount + this.data.payment.cheque_amount )}}</td>
                </tr>
                <tr>
                  <td class="text-end px-2">ប្រាក់បង់មុន</td>
                  <td class="text-end px-2">{{formatCurrency(this.data.payment.deposit_amount)}}</td>
                </tr>
                <tr>
                  <td class="text-end px-2">សាច់ប្រាក់</td>
                   <td class="text-end px-2">{{formatCurrency(this.data.payment.cash_amount)}}</td>
                </tr>
                <tr>
                  <td class="text-end px-2">តាមធនាគារ</td>
                   <td class="text-end px-2">{{formatCurrency(this.data.payment.bank_amount)}}</td>
                </tr>
                <tr>
                  <td class="text-end px-2">តាមសែក</td>
                   <td class="text-end px-2">{{formatCurrency(this.data.payment.cheque_amount)}}</td>
                </tr>
                <!-- end income  -->

                <!-- expense  -->
                <tr>
                  <td class="text-end px-2" colspan="2" rowspan="4">
                    ចំណាយ/Expense
                  </td>
                  <td class="text-end px-2 bg-secondary">ចំណាយសរុបទាំងអស់</td>
                  <td class="text-end px-2 bg-secondary">{{formatCurrency( this.data.expense.cash_amount + this.data.expense.bank_amount + this.data.expense.cheque_amount )}}</td>
                </tr>
                <tr>
                  <td class="text-end px-2">សាច់ប្រាក់</td>
                    <td class="text-end px-2">{{formatCurrency(this.data.expense.cash_amount)}}</td>
                </tr>
                <tr>
                  <td class="text-end px-2">តាមធនាគារ</td>
                    <td class="text-end px-2">{{formatCurrency(this.data.expense.bank_amount)}}</td>
                </tr>
                <tr>
                  <td class="text-end px-2">តាមសែក</td>
                    <td class="text-end px-2">{{formatCurrency(this.data.expense.cheque_amount)}}</td>
                </tr>
                 <!-- end expense  -->

                <!-- profit  -->
                <tr class="">
                  <td class="text-end px-2" colspan="2" rowspan="4">
                    ចំណេញ/Profit
                  </td>
                  <td class="text-end px-2 bg-secondary">ចំណេញសរុបទាំងអស់</td>
                  <td class="text-end px-2 bg-secondary">{{formatCurrency( (this.data.payment.cash_amount + this.data.payment.bank_amount + this.data.payment.cheque_amount + this.data.payment.deposit_amount) - (this.data.expense.cash_amount + this.data.expense.bank_amount + this.data.expense.cheque_amount) )}}</td>
                </tr>
                <tr>
                  <td class="text-end px-2">សាច់ប្រាក់</td>
                    <td class="text-end px-2">{{formatCurrency(this.data.payment.cash_amount > 0 ? this.data.payment.cash_amount -  this.data.expense.cash_amount : 0)}}</td>
                </tr>
                <tr>
                  <td class="text-end px-2">តាមធនាគារ</td>
                    <td class="text-end px-2">{{formatCurrency(this.data.payment.bank_amount>0 ? this.data.payment.bank_amount - this.data.expense.bank_amount : 0)}}</td>
                </tr>
                <tr>
                  <td class="text-end px-2">តាមសែក</td>
                    <td class="text-end px-2">{{formatCurrency(this.data.payment.cheque_amount >0 ? this.data.payment.cheque_amount - this.data.expense.cheque_amount : 0)}}</td>
                </tr>
                <!-- end profit  -->

              </tbody>
            </table>
            <div class="row mt-3">
              <div class="col text-center">
                <p>ឯកភាព និងទទួលស្គាលើដោយ <br> ហត្ថលេខា</p>
                <br><br>
                <p>លោកនាយកក្រុមហ៊ុន</p>
              </div>
              <div class="col text-center">
                <p>ត្រួតពិនិត្យដោយ <br> ហត្ថលេខា</p>
                <br><br>
                <p>អ្នកគ្រប់គ្រងទូទៅ</p>
              </div>
              <div class="col text-center">
                <p>ត្រួតពិនិត្យដោយ <br> ហត្ថលេខា</p>
                <br><br>
                <p>ជំនួយការអ្នកគ្រប់គ្រង</p>
              </div>
              <div class="col text-center">
                <p>ត្រួតពិនិត្យដោយ <br> ហត្ថលេខា</p>
                <br><br>
                <p>បុគ្គលិក</p>
              </div>
            </div>
            <br>
          </div>  
        <!-- </center> -->
      </div>
    <!-- end row -->
  </Layout>
</template>